// extracted by mini-css-extract-plugin
export var container = "_u0-0";
export var table = "_u0-2";
export var tableWrapper = "_u0-1";